import React, { Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg";
import Autocomplete from "react-autocomplete"
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { getlookupdocinfo, getlookuppageinfo } from "../../../../actions/ProjectMasterDataAction";
import { CssTextField, CssTextFieldLast } from "../../../custom/textField"

class ShipMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            Ship_List: [],
            NameError: false,
            UserRole: "",
            DeleteId: 0,
            Pagination: {
                "TotalPages": 0
            },
            searchData: {
                ProjectId: 0,
                Typeid: 0,
                isMasterData: true,
                PageNumber: 1,
                PageSize: 100,
            },
            newpostdata: {
                "ProjectId": 0,
                "TypeId": 0,
                "LookupName": "",
                "Section": "",
                "CreatedBy": "",
                "ModifiedBy": ""
            },
            postdataname: {
                "Id": 0,
                "Name": "",
                "Section": "",
                "Comments": "",
                "Status": "",
            },
            HoverId: 0,
            FocusId: 0,
            Name: "",
            render: false,
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.getTypes("DocumentTypes")
        this.state.searchData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.newpostdata.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.newpostdata.CreatedBy = localStorage.getItem("UserRoles");
        this.state.newpostdata.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }


    getTypes = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/type?type=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response.data.length > 0) {
                        let type = response.data.filter((val) => val.Name == "StatementOfCompletion")
                        this.state.searchData.Typeid = type[0].Id;
                        this.state.newpostdata.TypeId = type[0].Id;
                        this.state.TypeId = type[0].Id;
                        this.setState({})
                    }
                    this.dataTable(this.state.searchData)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTable = (data) => {
        let apiUrl = API.GET_DOCUMENTSNAME + '?ProjectId=' + data.ProjectId + '&Typeid=' + data.Typeid + '&isMasterData=' + data.isMasterData + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.Ship_List = [];
                    {
                        response.data?.Data && response.data?.Data.map((a) => (
                            a.Items && a.Items.map((s) => (
                                a.Name != "Completion Letter as per annexure VII" ?
                                    this.state.Ship_List.push(s) : <></>
                            ))
                        ))
                    }
                    this.setState({})
                    if (this.state.Ship_List.length == 0 || (this.state.Ship_List.length == 1 && this.state.Ship_List[this.state.Ship_List.length - 1].Name == "Completion Letter as per annexure VII")) {
                        this.post_data(this.state.newpostdata)
                    }
                    // this.state.Ship_List.sort((a, b) => {
                    //     return a.Id - b.Id;
                    // });
                    this.state.render = true;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#PROMAS4 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Promaster4 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Promaster44").addClass("d-none");
        $("#Promaster44").removeClass("d-block");
        // $("#MOPA").removeClass("active-color");
        // $("#MOPAT").removeClass("fw-bolder");
        this.props.dispatch({ type: "LOOKUP_DATAS", data: [] });
    }

    sidebar = () => {
        this.props.navigate("/sidebarprojectmasterdata");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#PROMAS4 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Promaster4 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Promaster44").removeClass("d-none");
        $("#Promaster44").addClass("d-block");
        // $("#MOPAT .MuiListItemText-primary").addClass("fw-bolder")
        // $("#MOPA").addClass("active-color")
    };

    post_data = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/ProjectLookups';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.showrow = false;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/UpdateProjectLookupField';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    handleInputChange = (e, str, val) => {
        if (val == "Name") {
            this.state.Ship_List.map((i) => (
                i.Id == str.Id ? i.Name = e.target.value : ""
            ))
            this.setState({})
        }
        if (e.target.value.trim() != "") {
            this.state.NameError = false;
            this.setState({})
        }
        else {
            this.state.NameError = true;
            this.setState({})
        }
    }

    handleInputChange1 = (e, str, val) => {
        let data = {
            Comments: str.Comments,
            Id: str.Id,
            Name: str.Name.trim(),
            Section: str.Section,
            Status: null
        }
        this.put_data(data)
        if (val == "Name") {
            this.state.Ship_List.map((i) => (
                i.Id == str.Id ? i.Name = e.target.value.trim() : ""
            ))
            this.setState({})
        }
    }

    handleFocusNameChange = (e, str, val) => {
        this.setState({ index: str.Id})
        if (e.target.value.trim().length > 0) {
            document.getElementById("actName" + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById("actName" + str.Id).focus()
        }
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {this.state.isMobile ?
                    <>
                        <div className="row border-bottom w-100 mt-4">
                            <div className="col-6 mt-auto">
                                <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem onClick={() => this.sidebar()} >
                                        <ListItemText id="PROMAS4" className='  textNaviIcon' primary="Master Data" />
                                        <NavigateNextIcon id="PROMAS44" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-6 pt-2 mt-5 ">
                                <h4>Statement of Completion</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
                }
                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Statement of Completion</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="DocsTable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="100%" style={{ minWidth: '100%', maxWidth: '100%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Document Name</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.render == true ? <>
                                        {this.state.Ship_List && this.state.Ship_List.map((i, index) => (
                                            i.Name != "Completion Letter as per annexure VII" ?
                                            <tr className="border-top" onMouseEnter={() => this.setState({ HoverDocId: i.Id })} onMouseLeave={() => this.setState({ HoverDocId: 0 })}>
                                                <td className="align-middle border-right border-left docname-set" style={{ minWidth: '97%', maxWidth: '97%' }}>
                                                    {(i.Name == "") ?
                                                        <CssTextFieldLast
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            id={"actName"+i.Id}
                                                            autoFocus={this.state.index == i.Id ? true : false}
                                                            onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                            onChange={(e) => this.handleInputChange(e, i, 'Name')}
                                                            onBlur={(e) => this.handleInputChange1(e, i, 'Name')}
                                                            value={i.Name}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} /> : <CssTextField
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            id={"actName"+i.Id}
                                                            autoFocus={this.state.index == i.Id ? true : false}
                                                            onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                            onChange={(e) => this.handleInputChange(e, i, 'Name')}
                                                            onBlur={(e) => this.handleInputChange1(e, i, 'Name')}
                                                            value={i.Name}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />}
                                                    {(i.Name == "") ?
                                                        <span className="pt-5" style={{ color: '#DD0000' }}>Document Name is required</span> : <></>}
                                                </td>
                                            </tr> : <></>
                                        ))} </> : <></> }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ShipMaster))
);
